export { ClientSearchModule } from './client-search.module';
export { ClientSearchComponent } from './client-search.component';